


export const bellRoutines = {
    MonTue: [
        {
            "period": "0",
            "startTime": "08:00",
            "endTime": "09:00",
            "type": "O",
            "time": "08:00",
            "bell": "0",
            "bellDisplay": "Period 0"
        },
        {
            "period": "RC",
            "startTime": "09:00",
            "endTime": "09:05",
            "type": "O",
            "time": "09:00",
            "bell": "RC",
            "bellDisplay": "Roll Call"
        },
        {
            "period": "1",
            "startTime": "09:05",
            "endTime": "10:05",
            "type": "T",
            "time": "09:05",
            "bell": "1",
            "bellDisplay": "Period 1"
        },
        {
            "period": "2",
            "startTime": "10:10",
            "endTime": "11:10",
            "type": "T",
            "time": "10:10",
            "bell": "2",
            "bellDisplay": "Period 2"
        },
        {
            "period": "R",
            "startTime": "11:10",
            "endTime": "11:30",
            "type": "R",
            "time": "11:10",
            "bell": "R",
            "bellDisplay": "Roll Call"
        },
        {
            "period": "3",
            "startTime": "11:30",
            "endTime": "12:30",
            "type": "T",
            "time": "11:30",
            "bell": "3",
            "bellDisplay": "Period 3"
        },
        {
            "period": "4",
            "startTime": "12:35",
            "endTime": "13:35",
            "type": "T",
            "time": "12:35",
            "bell": "4",
            "bellDisplay": "Period 4"
        },
        {
            "period": "MTL1",
            "startTime": "13:35",
            "endTime": "13:55",
            "type": "R",
            "time": "13:35",
            "bell": "MTL1",
            "bellDisplay": "MTL1"
        },
        {
            "period": "MTL2",
            "startTime": "13:55",
            "endTime": "14:15",
            "type": "R",
            "time": "13:55",
            "bell": "MTL2",
            "bellDisplay": "MTL2"
        },
        {
            "period": "5",
            "startTime": "14:15",
            "endTime": "15:15",
            "type": "T",
            "time": "14:15",
            "bell": "5",
            "bellDisplay": "Period 5"
        },
        {
            "period": "EoD",
            "startTime": "15:15",
            "endTime": null,
            "type": "O",
            "time": "15:15",
            "bell": "EoD",
            "bellDisplay": "End of Day"
        }
    ],
    WedThu: [
        {
            "period": "0",
            "startTime": "08:00",
            "endTime": "09:00",
            "type": "O",
            "time": "08:00",
            "bell": "0",
            "bellDisplay": "Period 0"
        },
        {
            "period": "RC",
            "startTime": "09:00",
            "endTime": "09:05",
            "type": "O",
            "time": "09:00",
            "bell": "RC",
            "bellDisplay": "Roll Call"
        },
        {
            "period": "1",
            "startTime": "09:05",
            "endTime": "10:05",
            "type": "T",
            "time": "09:05",
            "bell": "1",
            "bellDisplay": "Period 1"
        },
        {
            "period": "2",
            "startTime": "10:10",
            "endTime": "11:10",
            "type": "T",
            "time": "10:10",
            "bell": "2",
            "bellDisplay": "Period 2"
        },
        {
            "period": "R",
            "startTime": "11:10",
            "endTime": "11:30",
            "type": "R",
            "time": "11:10",
            "bell": "R",
            "bellDisplay": "Roll Call"
        },
        {
            "period": "3",
            "startTime": "11:30",
            "endTime": "12:30",
            "type": "T",
            "time": "11:30",
            "bell": "3",
            "bellDisplay": "Period 3"
        },
        {
            "period": "WTL1",
            "startTime": "12:30",
            "endTime": "12:50",
            "type": "R",
            "time": "12:30",
            "bell": "MTL1",
            "bellDisplay": "MTL1"
        },
        {
            "period": "WTL2",
            "startTime": "12:50",
            "endTime": "13:10",
            "type": "R",
            "time": "12:50",
            "bell": "MTL2",
            "bellDisplay": "MTL2"
        },
        {
            "period": "4",
            "startTime": "13:10",
            "endTime": "14:10",
            "type": "T",
            "time": "13:10",
            "bell": "4",
            "bellDisplay": "Period 4"
        },
        {
            "period": "5",
            "startTime": "14:15",
            "endTime": "15:15",
            "type": "T",
            "time": "14:15",
            "bell": "5",
            "bellDisplay": "Period 5"
        },
        {
            "period": "EoD",
            "startTime": "15:15",
            "endTime": null,
            "type": "O",
            "time": "15:15",
            "bell": "EoD",
            "bellDisplay": "End of Day"
        }
    ],
    Fri: [
        {
            "period": "0",
            "startTime": "08:00",
            "endTime": "09:25",
            "type": "O",
            "time": "08:00",
            "bell": "0",
            "bellDisplay": "Period 0"
        },
        {
            "period": "RC",
            "startTime": "09:25",
            "endTime": "09:30",
            "type": "O",
            "time": "09:25",
            "bell": "RC",
            "bellDisplay": "Roll Call"
        },
        {
            "period": "1",
            "startTime": "09:30",
            "endTime": "10:25",
            "type": "T",
            "time": "09:30",
            "bell": "1",
            "bellDisplay": "Period 1"
        },
        {
            "period": "2",
            "startTime": "10:30",
            "endTime": "11:25",
            "type": "T",
            "time": "10:30",
            "bell": "2",
            "bellDisplay": "Period 2"
        },
        {
            "period": "R",
            "startTime": "11:25",
            "endTime": "11:45",
            "type": "R",
            "time": "11:25",
            "bell": "R",
            "bellDisplay": "Break"
        },
        {
            "period": "3",
            "startTime": "11:45",
            "endTime": "12:40",
            "type": "T",
            "time": "11:45",
            "bell": "3",
            "bellDisplay": "Period 3"
        },
        {
            "period": "FL1",
            "startTime": "12:40",
            "endTime": "13:00",
            "type": "R",
            "time": "12:40",
            "bell": "FL1",
            "bellDisplay": "Lunch 1"
        },
        {
            "period": "FL2",
            "startTime": "13:00",
            "endTime": "13:20",
            "type": "R",
            "time": "13:00",
            "bell": "FL2",
            "bellDisplay": "Lunch 2"
        },
        {
            "period": "4",
            "startTime": "13:20",
            "endTime": "14:15",
            "type": "T",
            "time": "13:20",
            "bell": "4",
            "bellDisplay": "Period 4"
        },
        {
            "period": "5",
            "startTime": "14:20",
            "endTime": "15:15",
            "type": "T",
            "time": "14:20",
            "bell": "5",
            "bellDisplay": "Period 5"
        },
        {
            "period": "EoD",
            "startTime": "15:15",
            "endTime": null,
            "type": "O",
            "time": "15:15",
            "bell": "EoD",
            "bellDisplay": "End of Day"
        }
    ]

}